import React from "react";
import { ArrowRightIcon } from "lucide-react";
import { footerColumns } from "../data/footerLinks";
export function Footer() {
  return <footer className="w-full border-t border-white/[0.14] bg-ink px-6 pb-12 pt-[120px] lg:px-20" data-id="element-82" data-mp="3ggk72reij5xy">
      <div className="mx-auto max-w-page" data-id="element-83" data-mp="32pp6e2e63v5g">
        <div data-reveal className="flex flex-wrap items-start justify-between gap-10" data-id="element-84" data-mp="36p6b2tlrso9k">
          <div data-id="element-85" data-mp="3uf0mr7ucs6s8">
            <p className="text-[64px] font-semibold leading-[0.9] tracking-[-0.055em] text-white lg:text-[120px]" data-id="element-86" data-mp="3ueilfwsu32dg">
              Northgate Legal<span className="text-accent" data-id="element-87" data-mp="37fv17ktl04a">.</span>
            </p>
            <p className="mt-6 text-[17px] text-white/55" data-id="element-88" data-mp="3levih6kghoia">
              Clear advice. <span className="font-semibold text-white/85" data-id="element-89" data-mp="3lgos8uqd8oui">Considered</span> strategy.
            </p>
          </div>
          <a href="#contact" className="group mt-4 inline-flex h-[52px] items-center gap-3 rounded bg-accent px-7 text-[15px] font-semibold text-ink transition-colors duration-150 hover:bg-[#F0572F]" data-id="element-90" data-mp="29zgjxyclmol2">
            Book a Consultation
            <ArrowRightIcon className="h-4 w-4 transition-transform duration-200 ease-out group-hover:translate-x-1" strokeWidth={2} data-id="element-91" data-mp="3lbmuzun6vcgy" />
          </a>
        </div>

        <nav data-reveal data-reveal-delay="1" aria-label="Footer" className="mt-24 grid grid-cols-2 gap-10 border-t border-white/[0.14] pt-14 md:grid-cols-4 md:gap-6" data-id="element-92" data-mp="3v8hqe4o60wr0">
          {footerColumns.map(col => <div key={col.heading} data-id="element-93" data-mp="81fnrqp54i1k">
              <h2 className="text-[12px] font-semibold uppercase tracking-[0.16em] text-white/40" data-id="element-94" data-mp="33xdnwzdzwrz">
                {col.heading}
              </h2>
              <ul className="mt-6 space-y-3.5" data-id="element-95" data-mp="hrif7mgm5nxs">
                {col.links.map(link => <li key={link} data-id="element-96" data-mp="cus29803v8gl">
                    <a href="#" className="text-[15px] text-white/75 transition-colors duration-150 hover:text-white" data-id="element-97" data-mp="cvtp09qhhje5">
                      {link}
                    </a>
                  </li>)}
              </ul>
            </div>)}
        </nav>

        <div className="mt-24 flex flex-wrap items-end justify-between gap-6 border-t border-white/[0.14] pt-8" data-id="element-98" data-mp="twfnbqzkfrqu">
          <p className="max-w-[640px] text-[12px] leading-[1.6] text-white/35" data-id="element-99" data-mp="yuh7kf8q9x3w">
            Northgate Legal is a fictional placeholder brand. Regulatory, solicitor and SRA
            information should be replaced with the firm's verified legal details before
            publication.
          </p>
          <p className="text-[12px] text-white/35" data-id="element-100" data-mp="1clcjy1ifqwc8">© 2026 Northgate Legal. All rights reserved.</p>
        </div>
      </div>
    </footer>;
}